module.exports = "<div class=\"map-container\">\n  <div #map class=\"map\"></div>\n\n  <button\n    *ngIf=\"showSnapshotBtn\"\n    (click)=\"takeSnapshot()\"\n    class=\"snapshot-btn\">\n    📷 Snapshot\n  </button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/bizisystem-frontend/src/src/app/shared/google-map/google-map.component.html
// module id = ../../../../../src/app/shared/google-map/google-map.component.html
// module chunks = main